import React, { useState } from 'react';
import { Select, Checkbox } from 'antd';
import styles from './CustomSelect.module.scss';
import clsx from 'clsx';
import Input from '../Input/Input';
import { SearchOutlined } from '@ant-design/icons';
const CustomSelect = ({
        options = [],
        placeholder = 'Select an option',
        onChange,
        onSearch,
        showSearch = false,
        showSearchfield=false,
        placeholderRow = true,
        label,
        required,
        labelWidth = '120px',
        fieldName,
        className,
        id,
        width = '',
        packageCode = false,
        defaultValue,
        showIcon = false,
        icon = null,
        showCheckbox = false,
}) => {
        const [selectedOption, setSelectedOption] = useState(null);
        const [selectedValues, setSelectedValues] = useState([]);
        // Custom placeholder with Calendar Icon
        const customPlaceholder = (
                <div className="flex items-center gap-2 text-gray-400">
                        {showIcon && (
                                <img
                                        src={icon}
                                        alt="icon"
                                />
                        )}{' '}
                        <span className="text-[#344054] font-semibold font-inter text-[14px]">
                                {placeholder}
                        </span>
                </div>
        );

        const selectId = id || fieldName || `custom-select-${Math.random()}`;

        const finalOptions = options.map((opt) => ({
                label:
                        opt.value !== 'create-new' ? (
                                <div className="flex justify-between w-full">
                                        <span>{opt.label}</span>
                                        {packageCode && (
                                                <span className="text-gray-500">{opt.value}</span>
                                        )}
                                </div>
                        ) : (
                                opt.label
                        ),
                value: opt.value,
        }));

        const handleSelectChange = (value) => {
                if (packageCode) {
                        const selected = options.find((opt) => opt.value === value);
                        setSelectedOption(selected); // Store the selected object when packageCode is true
                        if (onChange) {
                                onChange(selected); // Pass the full object instead of just the value
                        }
                } else {
                        if (onChange) {
                                onChange(value); // Default behavior when packageCode is false
                        }
                }
        };

        const handleCheckboxChange = (checked, value) => {
                let updatedValues;
                if (checked) {
                        updatedValues = [...selectedValues, value];
                } else {
                        updatedValues = selectedValues.filter((item) => item !== value);
                }
                setSelectedValues(updatedValues);
                if (onChange) {
                        onChange(updatedValues);
                }
        };

        return (
                <div className={clsx('flex', placeholderRow ? 'flex-row items-center gap-4 pb-4' : 'flex-col gap-2')}>
                        {label && (
                                <label
                                        htmlFor={selectId}
                                        className={clsx(placeholderRow ? 'font-normal text-[16px] leading-[19px] text-[#232529]' : 'text-sm text-[#344054] font-semibold')}
                                        style={placeholderRow ? { minWidth: labelWidth } : {}}>
                                        {required && <span className="text-red-500 font-medium">*</span>} {label}{' '}
                                </label>
                        )}
                        <Select
                                id={selectId}
                                showSearch={showSearch}
                                placeholder={customPlaceholder}
                                optionFilterProp="label"
                                onChange={handleSelectChange}
                                onSearch={onSearch}
                                allowClear
                                options={finalOptions}
                                className={clsx(styles.customSelect, className)}
                                style={{ width }}
                                defaultValue={defaultValue}
                                dropdownRender={(menu) => (
                                        <div>
                                                {showSearchfield && (
                                                        <Input
                                                                placeholder="Search"
                                                                className="mb-2"
                                                                allowClear
                                                                prefix={<SearchOutlined />}
                                                        />
                                                )}
                                                {showCheckbox
                                                        ? options.map((opt) => (
                                                                  <div
                                                                          key={opt.value}
                                                                          className="flex items-center px-2 py-1">
                                                                          <Checkbox
                                                                                  checked={selectedValues.includes(opt.value)}
                                                                                  onChange={(e) => handleCheckboxChange(e.target.checked, opt.value)}>
                                                                                  {opt.label}
                                                                          </Checkbox>
                                                                  </div>
                                                          ))
                                                        : menu}
                                        </div>
                                )}
                        />
                </div>
        );
};

export default CustomSelect;
